import {useEffect, useState} from "react";
import {get, getToken} from "~/lib/ClientApi";
import emitter, {EmitterEventTypes} from "~/lib/emitter.js";

export function useClientLogin()
{
    const [isLoggedIn, setIsLoggedIn] = useState(false)
    const [isCheckingLogin, setIsCheckingLogin] = useState(false)
    const [clientUser, setClientUser] = useState(null)
    const [data, setData] = useState(null)

    function checkLogin()
    {
        if (!getToken()) {
            setIsLoggedIn(false);
            setClientUser(null);
        }

        setIsCheckingLogin(true);
        // Get user info
        get(`/account/info`).then((result) => {
            setClientUser(result?.user);
            setIsLoggedIn(!!result?.user);
            setData(result);
        }).catch((err) => {
            setIsLoggedIn(false);
        }).finally(() => {
            setIsCheckingLogin(false);
        });
    }

    useEffect(() => {
        if (getToken()) {
            checkLogin();
        }

        // Check anytime the token updates...
        function onTokenUpdated() {
            checkLogin();
        }

        emitter.on(EmitterEventTypes.CLIENT_TOKEN_UPDATED, onTokenUpdated);

        return () => emitter.off(EmitterEventTypes.CLIENT_TOKEN_UPDATED, onTokenUpdated)
    }, []);

    return {
        isCheckingLogin,
        isLoggedIn,
        clientUser,
        data,
    }
}
